import React, {
  createContext,
  ReactNode,
  useState,
  useEffect,
  useCallback,
} from "react";
import { authApiClient, AuthState, LogoutListener } from "../api/authApiClient";

export interface AuthProviderType {
  authState: AuthState;
  addLogoutListener: (listener: LogoutListener) => void;
}

export const AuthContext = createContext<AuthProviderType>(
  {} as AuthProviderType,
);

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const [authState, setAuthState] = useState<AuthState>(
    AuthState.LOADING_TOKEN,
  );

  // listen to changes on authApiClient auth state
  useEffect(() => {
    authApiClient.setAuthStateListener((newState) => {
      setAuthState(newState);
    });
  }, []);

  const addLogoutListener = useCallback((listener: () => void) => {
    authApiClient.addLogoutListener(listener);
  }, []);

  return (
    <AuthContext.Provider value={{ authState, addLogoutListener }}>
      {children}
    </AuthContext.Provider>
  );
};
